import FundamentalSubNavigation from './FundamentalSubNavigation';
import { isDesktop } from '../../utils';
import { USER_INTERACTION_EVENTS } from '../../constants';

class FeatureSubNavigation extends FundamentalSubNavigation {
  constructor(el) {
    super(el);

    this.text = {
      ...this.text,
      top: 'top',
    };

    this.isSubNavTopOnHeaderDesktop = false;
    this.init();
  }

  init() {
    super.init();
    this.initPinSubNavAction();
    this.addListeners();
  }

  addListeners() {
    super.addListeners();
    window.scrollAgent.scrollEvent(() => {
      if (isDesktop()) {
        this.pinSubNav();
      }
    });
    $(window).on('scroll', () => {
      if (!isDesktop()) {
        this.customScrollTop = $(window).scrollTop();
        this.pinSubNav();
      }
    });
  }

  // init pin subnav action when user has any action
  initPinSubNavAction() {
    this.dom.$body.addClass('feature-template');
    $(window).on(USER_INTERACTION_EVENTS, () => {
      if (isDesktop() && !this.isSubNavTopOnHeaderDesktop) {
        this.dom.$body.addClass('feature-pin-desktop');
        this.isSubNavTopOnHeaderDesktop = true;
        this.dom.$header.after(this.dom.$subNav);
      }
    });
  }

  pinSubNavDesktopAction() {
    this.dom.$header.after(this.dom.$subNav);
    this.$el.css('height', this.dom.$subNav.outerHeight());
    this.dom.$subNav.addClass(this.classes.pinSubNav);
    this.navIsPinned = true;
  }

  unPinSubNavDesktopAction() {
    // remove class to subnav & other styles when unpin
    this.$el.append(this.dom.$subNav).css('height', '');
    this.dom.$subNav.removeClass(this.classes.pinSubNav);
    this.navIsPinned = false;
  }

  pinSubNav() {
    const headerHeight = this.dom.$header.outerHeight();
    this.dom.$header.css(this.text.top, `${Math.max(-this.customScrollTop, -headerHeight)}px`).css({ transform: 'none', transition: 'none' });
    if (isDesktop()) {
      this.dom.$subNav.css(this.text.top, `${Math.max(headerHeight - this.customScrollTop, 0)}px`);
      this.dom.$groupContentTop.css(this.text.top, '').css({ transform: 'none', transition: 'none' });
      this.resetUnpinGroupBottomAboveFooterMobile();
    } else {
      this.dom.$subNav.css(this.text.top, '');
      this.dom.$groupContentTop.css(this.text.top, `${Math.max(headerHeight - this.customScrollTop, 0)}px`).css({ transform: 'none', transition: 'none' });
      this.unpinGroupBottomAboveFooterMobile();
    }
  }

  /* ********************* */
  /* Layout */
  calculateSubNavDropdownScrollableHeight() {
    const headerHeightVisibleWithScroll = Math.max(this.dom.$header.outerHeight() - this.customScrollTop, 0);
    const screenHeight = document.documentElement.clientHeight || window.innerHeight;
    const height = screenHeight - headerHeightVisibleWithScroll - this.dom.$groupContentBottom.outerHeight();
    if (!isDesktop()) {
      this.dom.$groupContentTopInner.css('max-height', height);
    } else {
      this.dom.$groupContentTopInner.css('max-height', '');
    }
  }
}
export default FeatureSubNavigation;